var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDexisLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.2857;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.6429;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,48.7c-3.8,13-15.9,22.6-30.3,22.6C22.1,71.3,8,57.3,8,40C8,22.8,22.1,8.8,39.5,8.8S71,22.8,71,40 c0,1-0.1,1.9-0.1,2.9h4.5c0.1-0.9,0.1-1.9,0.1-2.9c0-19.9-16.1-36-36-36c-19.9,0-36,16.1-36,36c0,19.9,16.1,36,36,36 c16.9,0,31.1-11.6,34.9-27.3H69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,48.4c-3.3,8.3-11.4,14.2-20.9,14.2C18.7,62.5,8.6,52.4,8.6,40s10.1-22.5,22.5-22.5S53.6,27.6,53.6,40 c0,0.9-0.1,1.7-0.1,2.6h5.2c0.1-0.8,0.1-1.7,0.1-2.6c0-15.3-12.4-27.6-27.6-27.6S3.5,24.7,3.5,40s12.4,27.6,27.6,27.6 c12.4,0,22.8-8.1,26.4-19.3H52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,42.9h18v-2.8c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1v-2.8h-0.2c-1.4-8.9-9.1-15.7-18.4-15.7 C11.9,21.4,3.5,29.7,3.5,40c0,10.3,8.3,18.6,18.6,18.6c7.3,0,13.6-4.2,16.7-10.3h-6.1c-2.5,3.1-6.3,5.2-10.6,5.2 c-7.5,0-13.5-6-13.5-13.5c0-7.5,6-13.5,13.5-13.5c6.5,0,11.9,4.5,13.2,10.6H22.8V42.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexisLogo);
export default __webpack_public_path__ + "static/media/dexis_logo.2247b71eaa25f142a42149f323202064.svg";
export { ForwardRef as ReactComponent };